import React, { useEffect, useState } from "react";
import { useI18n } from "../i18n/I18nProvider";

const WELCOME_KEY = "portfolio-lang-welcome-shown";

function LanguageWelcomeModal() {
  const { setLocale, t } = useI18n();
  const [open, setOpen] = useState(() => {
    try {
      return !localStorage.getItem(WELCOME_KEY);
    } catch {
      return false;
    }
  });

  const closeAndRemember = () => {
    try {
      localStorage.setItem(WELCOME_KEY, "1");
    } catch {
      /* ignore */
    }
    setOpen(false);
  };

  const choose = (code) => {
    setLocale(code);
    closeAndRemember();
  };

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="lang-welcome-overlay"
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) closeAndRemember();
      }}
    >
      <div
        className="lang-welcome-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="lang-welcome-title"
        aria-describedby="lang-welcome-desc"
      >
        <div className="lang-welcome-brand" aria-hidden>
          <span className="lang-welcome-icon">
            <i className="fa fa-language" />
          </span>
        </div>
        <h2 id="lang-welcome-title" className="lang-welcome-title">
          {t("welcome.title")}
        </h2>
        <p id="lang-welcome-desc" className="lang-welcome-subtitle">
          {t("welcome.subtitle")}
        </p>
        <div className="lang-welcome-actions">
          <button
            type="button"
            className="lang-welcome-btn lang-welcome-btn--en pro-btn pro-btn--primary"
            onClick={() => choose("en")}
          >
            {t("welcome.english")}
          </button>
          <button
            type="button"
            className="lang-welcome-btn lang-welcome-btn--fr pro-btn pro-btn--primary"
            onClick={() => choose("fr")}
          >
            {t("welcome.french")}
          </button>
          <button
            type="button"
            className="lang-welcome-btn lang-welcome-btn--ar pro-btn pro-btn--primary"
            onClick={() => choose("ar")}
          >
            {t("welcome.arabic")}
          </button>
        </div>
        <button
          type="button"
          className="lang-welcome-later"
          onClick={closeAndRemember}
        >
          {t("welcome.later")}
        </button>
      </div>
    </div>
  );
}

export default LanguageWelcomeModal;
